import { SKIP_DYNAMIC_RENDER } from "../../../src/utils/utils";

export const validateStaticField = (fieldName, value) => {
  switch (fieldName) {
    case "first_name":
      if (!value) return "Payee name is required.";
      if (value.length < 2) return "Name must be at least 2 characters.";
      if (value.length > 50) return "Name cannot exceed 50 characters.";
      if (!/^[a-zA-Z\s]+$/.test(value))
        return "Name can only contain letters and spaces.";
      return "";

    case "last_name":
      if (!value) return "Payee last name is required.";
      if (value.length < 2) return "Name must be at least 2 characters.";
      if (value.length > 50) return "Name cannot exceed 50 characters.";
      if (!/^[a-zA-Z\s]+$/.test(value))
        return "Name can only contain letters and spaces.";
      return "";

    case "entity_type":
      if (!value) return "Payee Type is required.";
      return "";

    case "country_code":
      if (!value) return "Payee Country is required.";
      return "";

    case "payment_method":
      if (!value) return "Transfer Method is required.";
      return "";

    case "state":
      if (!value) return "State is required.";
      if (value.length < 2) return "State must be at least 2 characters.";
      if (value.length > 50) return "State cannot exceed 50 characters.";
      if (!/^[a-zA-Z\s-]+$/.test(value))
      return "State can only contain letters, spaces, and hyphens.";
      return "";

    case "city":
      if (!value) return "City is required.";
      if (value.length < 2) return "City must be at least 2 characters.";
      if (value.length > 50) return "City cannot exceed 50 characters.";
      if (!/^[a-zA-Z\s]+$/.test(value))
        return "City can only contain letters and spaces.";
      return "";

    case "street_address":
    case "address_line1":
      if (!value) return "Address is required.";
      if (value.length < 5) return "Address must be at least 5 characters.";
      if (value.length > 200) return "Address cannot exceed 200 characters.";
      return "";

    case "postcode":
    case "zip_code":
      if (!value) return "Postal code is required.";
      return "";

    default:
      return "";
    case "swift_code":
      if (!value) return "SWIFT code is required.";
      if (!/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(value))
        return "Invalid SWIFT code format.";
      return "";
  }
};
export const validateDynamicField = (field, value) => {
  if (!field) return "";

  const val = value ?? "";

  if (!field.required && String(val).trim() === "") return "";

  if (field.required && String(val).trim() === "") {
    return `${field.displayName} is required`;
  }

  if (field.validation && field.fieldName !== "state") {
    const regex = new RegExp(field.validation);
    if (!regex.test(val)) return `Invalid ${field.displayName}`;
  }

  return "";
};
export const validateMainStep = (trimmedForm, accountFields = []) => {
  const errors = {};

  const staticFields = [
    "entity_type",
    "first_name",
    "last_name",
    "country_code",
    "payment_method",
  ];
  staticFields.forEach((key) => {
    const err = validateStaticField(key, trimmedForm[key]);
    if (err) errors[key] = err;
  });

  accountFields.forEach((field) => {
    if (SKIP_DYNAMIC_RENDER.has(field.fieldName)) return;
    const err = validateDynamicField(field, trimmedForm[field.fieldName]);
    if (err) errors[field.fieldName] = err;
  });

  return { errors, isValid: Object.keys(errors).length === 0 };
};
export const validateAddressStep = (trimmedForm, addressFields = []) => {
  const errors = {};

  addressFields.forEach((field) => {
    if (SKIP_DYNAMIC_RENDER.has(field.fieldName)) return;

    const value = trimmedForm[field.fieldName];

    if (field.required) {
    const staticErr = validateStaticField(field.fieldName, value);
    if (staticErr) {
      errors[field.fieldName] = staticErr;
      return;
      }
    }

    const dynamicErr = validateDynamicField(field, value);
    if (dynamicErr) errors[field.fieldName] = dynamicErr;
  });

  return { errors, isValid: Object.keys(errors).length === 0 };
};
